export const isSSR = navigator?.userAgent === "ReactSnap";
